<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vx-card>
        <div>
          <vs-table
            v-if="isRegionsListValid"
            @selected="handleSelected"
            :max-items="paginationItems[1]"
            pagination
            :data="RegionsList"
            :description="false"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.PriceRegion") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Price Region' })"
                  size="small"
                  >{{ $t("setup.label.CreatePriceRegion") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.RegionCode") }}</vs-th>
              <vs-th>{{ $t("setup.label.RegionName") }}</vs-th>

              <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="RegionsList"
                v-for="(RegionsList, index) in data"
              >
                <vs-td :data="RegionsList.regionCode">{{
                  RegionsList.regionCode
                }}</vs-td>
                <vs-td :data="RegionsList.regionName">{{
                  RegionsList.regionName
                }}</vs-td>

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EyeIcon"
                      :title="$t('setup.label.View')"
                      svgClasses="w-5 h-5 stroke-current cursor text-primary"
                      @click.stop="handleSelected(RegionsList)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editPriceRegion(RegionsList.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="
                        deletePriceRegionPopup = true;
                        delId = RegionsList.id;
                      "
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deletePriceRegionPopup"
      :title="$t('setup.label.PriceRegion')"
      @deletePressed="deletePriceRegion(delId)"
      @cancelPressed="deletePriceRegionPopup = false"
    ></delete-popup>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      deletePriceRegionPopup: false,
      paginationItems: [5, 10, 15],
      delId: 0,
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapGetters({
      RegionsList: "priceRegion/getRegionsList",
    }),
    isRegionsListValid() {
      return Array.isArray(this.RegionsList);
    },
  },
  methods: {
    handleSelected(region) {
      this.$router.push({
        name: "View Price Region",
        params: { id: region.id },
      });
    },
    async deletePriceRegion(id) {
      try {
        this.deletePriceRegionPopup = false;
        await this.$store.dispatch("priceRegion/deletepriceRegionAction", id);
        await this.getPriceList();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getPriceList() {
      this.loading = true;
      try {
        await this.$store.dispatch("priceRegion/setRegions");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    editPriceRegion(id) {
      this.$router.push({ name: "Edit Price Region", params: { id: id } });
    },
  },
  async mounted() {
    await this.getPriceList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
